import script from "./sf-banner-page.vue?vue&type=script&setup=true&lang=ts"
export * from "./sf-banner-page.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__